import { useContext } from "react";
import context, { IProjectProviderContext } from "../state/context";

export default (): IProjectProviderContext => useContext(context);
